<template>
  <div class="advanced-search">
    <div class="main-content">
      <div class="icon-title">
        <img
          :src="require('@/assets/images/SearchPage/search.png')"
          alt="检索"
          class="icon"
        />
        <span class="title">高级检索</span>
      </div>
      <advanced-search-form></advanced-search-form>
    </div>
    <div class="side-help">
      <div class="help-text">
        <div class="help-title">
          高级检索使用方法
        </div>
        <div class="help-content">
          请输入检索词。可用“+”表示“与”，“空格”表示“或”，"-"表示非 进行组合检索
          <br />
          <br />
          例如：
          <br />
          （1）黄芪+人参可以检索到包含黄芪和人参的相关内容；
          <br />
          （2）黄芪 人参可以检索到包含黄芪或人参的相关内容；
          <br />
          （3） -黄芪 可以检索不包含黄芪的内容。
          <br />
          <br />
          对于成书区间的检索：
          （1）若起始年份输入-500，终止年份输入1000，则检索结果为公元前500年到1000年的所有成书。
          <br />
          （2）年份只能输入数字（如-500，1000等），且起始年份不能大于终止年份。
        </div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import MyDropdown from '../../components/MyDropdown.vue'
import WordList from '../../components/WordList.vue'
import MySearchDropDown from '../../components/MySearchDropDown.vue'
import AdvancedSearchForm from '../../components/AdvancedSearchForm.vue'
export default {
  components: { MyDropdown, WordList, MySearchDropDown, AdvancedSearchForm },
  name: 'AdvancedSearch'
}
</script>

<style scoped>
.advanced-search {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
}

.main-content {
  width: 960px;
  height: 800px;
  background-color: #fff;
  padding-left: 20px;
  padding-top: 10px;
  padding-right: 20px;
}

.side-help {
  width: 200px;
  height: 800px;
  background-color: #fff;
  margin-left: 30px;
  padding: 20px;
}

.inputs-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
  position: relative;
  width: 785px;
}

.inputs-row.inputs-time {
  justify-content: left;
}

.inputs-time >>> .el-input {
  width: 140px;
}

.mid-text {
  margin-left: 10px;
  margin-right: 10px;
}

.icon-title {
  display: flex;
  align-items: center;
  justify-content: left;
  border-bottom: 1px solid #9e5c1d;
  width: 156px;
  height: 50px;
  font-size: 18px;
  font-weight: bold;
  color: #9e5c1d;
}

.icon {
  width: 34px;
  margin-right: 10px;
}

.icon-label {
  display: flex;
  align-items: center;
  justify-content: left;
}

.label-icon {
  width: 18px;
  margin-right: 7px;
}

.label-text {
  font-size: 16px;
  font-weight: bold;
  color: #634c37;
  width: 64px;
  text-align: justify;
  text-align-last: justify;
}

.advanced-search >>> .el-input__inner {
  height: 40px;
  border: 1px solid #634c37;
  border-radius: 0;
  color: #634c37;
  font-size: 14px;
  padding: 0 0 0 25px;
}

.advanced-search >>> .el-input__inner:hover {
  border: 1px solid #9e5c1d;
}

.advanced-search >>> .el-input__inner:focus {
  border: 1px solid #9e5c1d;
}

.advanced-search >>> .el-select .el-input .el-select__caret::before {
  color: #634c37;
  font-size: 24px;
}

.advanced-search >>> .el-cascader .el-input__icon:before {
  color: #634c37;
  font-size: 24px;
  transform: translate(-50%, -50%);
}

.form {
  width: 785px;
  margin-bottom: 30px;
}

.inputs-row-wrapper {
  width: 885px;
  display: flex;
  align-items: center;
}

.add-link {
  color: #9e5c1d;
  font-size: 16px;
  cursor: pointer;
  text-decoration: underline;
  margin-top: 15px;
  margin-left: 20px;
}

.left-input {
  width: 210px;
  margin-right: 40px;
}

.right-input {
  width: 307px;
}

.advanced-search >>> .my-dropdown-content {
  position: absolute;
  top: 50px;
  left: -680px;
}

.help-text {
  width: 162px;
  padding: 14px;
  background: rgba(244, 242, 241, 0.26);
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  border: 1px solid #f4f2f1;
  text-align: left;
  margin: auto;
  margin-top: 54px;
}

.help-title {
  font-size: 16px;
  font-weight: bold;
  color: #634c37;
  margin-bottom: 10px;
}

.help-content {
  font-size: 14px;
  color: #634c37;
  line-height: 1.5;
}

.footer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding-top: 20px;
  border-top: 1px solid #f4f2f1;
}

.cancel-button {
  width: 138px;
  height: 40px;
  background: #ffffff;
  opacity: 1;
  border: 1px solid #9e5c1d;
  color: #634c37;
  display: flex;
  align-items: center;
  margin: 0 20px;
  justify-content: center;
  cursor: pointer;
}

.confirm-button {
  width: 138px;
  height: 40px;
  background: #9e5c1d;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  border: 0;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.confirm-button span,
.cancel-button span {
  min-width: 50px;
  width: max-content;
  text-align: justify;
  text-align-last: justify;
}

.button-icon {
  width: 24px;
  margin-right: 7px;
}

.advanced-search >>> .el-select-dropdown__item {
  color: #634c37;
  font-size: 14px;
}

.advanced-search >>> .el-select-dropdown__item.hover {
  background-color: #9e5c1d;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/retrieve/AdvancedSearch.vue